export default "__VITE_ASSET__CpxgkowU__"